import { isTottusStandalone } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { style as createListStyles } from './CreateList.style';

const CreateList = ({ showForm, label, appCtx }) => {
  const { store = '' } = appCtx;
  const isTottusSA = isTottusStandalone(store);
  const setFormVisible = () => {
    showForm(true);
  };

  return (
    <button id="create-new-list" type="button" onClick={setFormVisible} className="create-list-button">
      <i className={`csicon-add${isTottusSA ? ' tottus' : ''}`} />
      <span className={`button-text${isTottusSA ? ' tottus' : ''}`}>{label}</span>
      <style jsx>{createListStyles}</style>
    </button>
  );
};

CreateList.propTypes = {
  showForm: PropTypes.func.isRequired,
  label: PropTypes.string,
  appCtx: PropTypes.object.isRequired,
};

CreateList.defaultProps = {
  label: 'Crear una nueva lista',
};

export default withApplicationContext(CreateList);
